module.exports = __webpack_public_path__ + "static/media/scene-accessibility.5bf80fb3.svg";